import { Avatar, Space, Tooltip, Typography } from 'antd'
import { AvatarProps } from 'antd/es/avatar'
import { Employee as EmployeeModel } from '../../models/Employee'

const { Text } = Typography

interface Props {
  model: EmployeeModel
  size?: AvatarProps['size']
  type?: 'full' | 'condensed'
}

export const EmployeeAvatar = ({
  model,
  type = 'full',
  size = 'default',
}: Props) => {
  const employee = model

  if (!employee) {
    return <></>
  }

  return (
    <Space>
      <Tooltip
        title={`${employee.firstName}`}
        open={type == 'full' ? false : undefined}
      >
        <Avatar
          size={size == 'large' ? 60 : size}
          style={{
            color: '#fff',
            backgroundColor: '#5d5df6',
            fontSize: size == 'small' ? 11 : undefined,
          }}
        >
          <div style={{ textTransform: 'uppercase' }}>
            {employee.firstName && employee.firstName.slice(0, 1)}
            {employee.lastName && employee.lastName.slice(0, 1)}
            {!employee.firstName && !employee.lastName && '--'}
          </div>
        </Avatar>
      </Tooltip>
      {type == 'full' && (
        <Space.Compact vertical>
          <Space.Compact vertical>
            <Text>
              {employee.firstName} {employee.lastName}
            </Text>
            {size != 'small' && (
              <Text type="secondary">#{employee.matricule}</Text>
            )}
          </Space.Compact>
        </Space.Compact>
      )}
    </Space>
  )
}

export type EmployeeAvatarType = { Avatar: typeof EmployeeAvatar }
